import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Button from './_button.js'
import Intent from './_intent.js'
import DocumentHead from './_document-head.js'

export default {
  name: 'EmptyContent',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '40px',
        style: {
          flexDirection: 'column',
          alignItems: 'center',
          padding: '40px 0 40px 0',
        },
      },
    },
    textContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          maxWidth: '312px',
        },
      },
    },
    text: {
      configSet: Text,
      configValues: {},
    },
    button: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '40px',
          },
        },
      },
    },
    buttonLabel: {
      configSet: Text,
      configValues: {},
    },
    buttonIntent: {
      configSet: Intent,
      configValues: {},
    },
    documentHeadMetaFactory: undefined,
    documentHeadEmptyContent: {
      configSet: DocumentHead,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
